import Sidebar from "../components/sidebar/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../hooks/useAuth";
import React, { useState, useEffect } from "react";
import CustomHtags from "../components/new/typography/CustomHtags";
import CustomPtags from "../components/new/typography/CustomPtags";
import CustomInput1 from "../components/new/inputs/CustomInput1";
import CustomFilledButton from "../components/new/buttons/CustomFilledButton";
import CustomOutlined from "../components/new/buttons/CustomOutlined";
import jwtDecode from "jwt-decode";
import useAdditionalInfoCheck from "../hooks/useAdditionalInfoCheck";
import usePaymentStatusCheck from "../hooks/usePaymentCheck";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoaderComponent from "../components/loaderCompent/LoaderComponent"; // Import the loader component
import CustomAlert from "../components/alert/CustomAlert"; // Import CustomAlert

const Paymentpage = () => {
  const { isSidebarOpen } = useAuth();
  const navigate = useNavigate();
  const additionalInfoIsAdded = useAdditionalInfoCheck();
  const [fallbackMessage, setFallbackMessage] = useState(null);
  const [alert, setAlert] = useState(null); // State for CustomAlert

  // Decode token and extract user info
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.result?.token;
  let decodedToken = null;
  if (token) {
    decodedToken = jwtDecode(token);
  }

  const [formData, setFormData] = useState({
    name: decodedToken?.username || "", // Prepopulate username
    email: decodedToken?.email || "", // Prepopulate email
    phone: decodedToken?.mobile || "", // Prepopulate mobile
    buyerId: localStorage.getItem("userId"),
  });

  const paymentStatus = usePaymentStatusCheck();
  const [isLoading, setIsLoading] = useState(false); // State to track loading

  useEffect(() => {
    if (paymentStatus === "requested") {
      console.log("Payment is still requested.");
    } else if (paymentStatus === "completed") {
      console.log("Payment has been completed.");
    } else if (paymentStatus === "inProgress") {
      console.log("Payment is in progress.");
    } else if (paymentStatus === "failed") {
      console.log("Payment failed. Please try again.");
    }
  }, [paymentStatus]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setFallbackMessage(null); // Clear any previous fallback message
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user/requestPaymentQuote`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setAlert({
          message: "Your request has been submitted successfully.",
          type: "success",
          visible: true,
        });
        setFallbackMessage(null); // Clear fallback message if alert works
      } else {
        const errorMessage = data.message || "Something went wrong. Please try again.";
        setAlert({
          message: errorMessage,
          type: "error"
        });
        setFallbackMessage(errorMessage); // Set fallback message
      }
    } catch (error) {
      console.error(error);
      setAlert({
        message: "An unexpected error occurred. Please try again.",
        type: "error"
      });
      setFallbackMessage("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-[1920px] relative m-auto mt-[64px] sm:mt-[64px]  flex">
      {/* Loader Modal */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
          <div className="bg-white p-4 rounded-lg shadow-lg ">
            <LoaderComponent width="80" height="80" />
          </div>
        </div>
      )}

      {/* Custom Alert */}
      {alert && (
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert(null)}
                />
            )}

      <div className="hidden sm:block">
        <Sidebar type={2} />
      </div>

      <div className="ml-[10px] bg-[#F7F3EC] sm:ml-[80px] min-h-[calc(100vh-64px)] w-full px-[10px]  flex-1 transition-width duration-300">
        {/* Main Card */}
        <div className="  rounded-2xl p-8 pt-12 flex flex-col lg:flex-row gap-8">
          {/* Left Section - Features */}
          <div className="flex-1 px-[32px] min-w-[1044px]">
            <CustomHtags
              type="desktop"
              tagType="header"
              subType="h3"
              style={{ color: "#797979" }} // Optional inline styles
            >
              Custom Premium Plans
            </CustomHtags>
            <div className="py-[16px]">
              <CustomPtags
                type="desktop"
                subType="p1"
                fontWeight="regular"
                className=""
                style={{ color: "#797979" }} // Optional inline styles
              >
                AmpeX can do beyond consolidate your bill data. It can
              </CustomPtags>
            </div>
            <ul className="space-y-4 gap-[16px] text-gray-700">
              <li className="flex items-center gap-[16px]">
                <img
                  src="/rightIcon.svg"
                  alt="Right Icon"
                  className="text-gray-500"
                  style={{
                    width: "18px",
                    height: "18px",
                    verticalAlign: "middle",
                  }}
                />
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  style={{
                    fontWeight: "medium",
                    color: "#4A4A4A",
                  }}
                >
                  Suggest{" "}
                  <span className="text-green-600 font-medium">
                    Green Power
                  </span>{" "}
                  options specific to your business
                </CustomPtags>
              </li>
              <li className="flex items-center gap-[16px]">
                <img
                  src="/rightIcon.svg"
                  alt="Right Icon"
                  icon={faCheckCircle}
                  className="text-gray-500"
                  style={{ width: "18px", height: "18px" }}
                />
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  style={{
                    fontWeight: "medium",
                    color: "#4A4A4A",
                  }}
                >
                  Keep you updated with{" "}
                  <span className="text-green-600 font-medium">
                    Power Exchange
                  </span>{" "}
                  tariff per unit and recommend cheaper energy purchase options
                </CustomPtags>
              </li>
              <li className="flex items-start gap-[16px]">
                <img
                  src="/rightIcon.svg"
                  alt="Right Icon"
                  icon={faCheckCircle}
                  className="text-gray-500 mt-[4px]"
                  style={{ width: "18px", height: "18px" }}
                />
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  style={{
                    fontWeight: "medium",
                    color: "#4A4A4A",
                  }}
                >
                  Optimize electricity consumption{" "}
                  <span className="text-green-600 font-medium">
                    reducing Scope II emissions
                  </span>
                </CustomPtags>
              </li>
              <li className="flex items-start gap-[16px]">
                <img
                  src="/rightIcon.svg"
                  alt="Right Icon"
                  icon={faCheckCircle}
                  className="text-gray-500 mt-[4px]"
                  style={{ width: "18px", height: "18px" }}
                />
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  style={{
                    fontWeight: "medium",
                    color: "#4A4A4A",
                  }}
                >
                  Analyze missed{" "}
                  <span className="text-green-600 font-medium">incentive</span>{" "}
                  opportunities and generate alerts to save on future incentive
                  savings
                </CustomPtags>
              </li>
              <li className="flex items-start gap-[16px]">
                <img
                  src="/rightIcon.svg"
                  alt="Right Icon"
                  icon={faCheckCircle}
                  className="text-gray-500 mt-[4px]"
                  style={{ width: "18px", height: "18px" }}
                />
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  style={{
                    fontWeight: "medium",
                    color: "#4A4A4A",
                  }}
                >
                  Analyze incurred{" "}
                  <span className="text-green-600 font-medium">penalty</span>{" "}
                  and generate alerts to save on all future penalties
                </CustomPtags>
              </li>
              <li className="flex items-start gap-[16px]">
                <img
                  src="/rightIcon.svg"
                  alt="Right Icon"
                  icon={faCheckCircle}
                  className="text-gray-500 mt-[4px]"
                  style={{ width: "18px", height: "18px" }}
                />
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  style={{
                    fontWeight: "medium",
                    color: "#4A4A4A",
                  }}
                >
                  Optimize electricity costs through State and Discom specific{" "}
                  <span className="text-green-600 font-medium">
                    TOD adjustments
                  </span>
                </CustomPtags>
              </li>
            </ul>

            {/* Inquiry Form */}
            <div className="bg-white  p-[16px] rounded-xl mt-[16px]">
              <div className="pb-[16px]">
                <CustomHtags
                  type="desktop"
                  tagType="header"
                  subType="h3"
                  style={{ color: "#797979" }}
                >
                  Inquire now
                </CustomHtags>
              </div>
              <div className="pb-[16px]">
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  fontWeight="regular"
                  className="mb-[16px]"
                  style={{
                    color: "#797979",
                    paddingBottom: "16px",
                  }} // Optional inline styles
                >
                  Every Business is unique. We want to bring the best pricing
                  for you!
                </CustomPtags>
              </div>
              {/* Form */}
              <form className="">
                <div className="flex justify-start !gap-[16px]">
                  <div className="">
                    <CustomInput1
                      label="Name"
                      value={formData.name}
                      placeholder="Username"
                      onChange={(e) => handleChange(e)}
                      name="name"
                      style={{ width: "100%" }} // Set specific width
                    />
                  </div>
                  <div className="">
                    <CustomInput1
                      label="Email"
                      value={formData.email}
                      placeholder="Email"
                      onChange={(e) => handleChange(e)}
                      name="email"
                      style={{ width: "100%" }} // Set specific width
                    />
                  </div>
                  <div className="">
                    <CustomInput1
                      label="Phone"
                      value={formData.phone}
                      placeholder="Phone"
                      onChange={(e) => handleChange(e)}
                      name="phone"
                      style={{ width: "100%" }} // Set specific width
                    />
                  </div>
                </div>
                <div className="flex justify-start gap-[16px] mt-[16px] col-span-full">
                  <>
                    <CustomFilledButton
                      label="Request for Quote"
                      onClick={handleSubmit}
                      disabled={paymentStatus === "completed" || isLoading} // Disable button while loading
                    />
                  </>
                  {!additionalInfoIsAdded && (
                    <CustomOutlined onClick={() => navigate("/additionalinfo")}>
                      Complete Profile
                    </CustomOutlined>
                  )}
                </div>
                {fallbackMessage && (
                  <div className="mt-4 text-red-500">{fallbackMessage}</div>
                )}
              </form>

              {/* Warning Message */}
              {!additionalInfoIsAdded ? (
                <CustomPtags
                  type="desktop"
                  subType="p1"
                  fontWeight="regular"
                  className="text-orange-500 mt-4 flex items-center gap-2"
                >
                  <FontAwesomeIcon
                    icon={faCircleExclamation}
                    className="text-orange-500"
                  />
                  Your Profile is not complete. Please fill additional details
                  for us to serve you better.
                </CustomPtags>
              ) : null}
            </div>
          </div>

          {/* Right Section - Pricing Graphic (Placeholder) */}
          <div className="flex-1 flex w-full items-center justify-center mb-[10rem]">
            <div className="w-full rounded-xl flex items-start justify-center overflow-hidden">
              <img
                src="/paymentInfoSideImage.svg"
                alt="Pricing Graphic"
                style={{ width: "737px", height: "581px" }}
                className="object-contain h-full w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paymentpage;
